module.exports = __webpack_public_path__ + "img/heating.a06e3d21.png";